import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Baby } from "lucide-react";
import { Link } from "react-router-dom";
const LifecycleNutrition = () => {
  return <>
      <section id="lifecycle-nutrition" className="py-16">
        <div className="container mx-auto px-4">
          <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 bg-[#fedd7d]/20">
            <CardHeader className="flex flex-row items-center gap-4">
              <div className="p-4 rounded-full bg-[#fedd7d]/50">
                <Baby className="w-8 h-8 text-[#85a3a6]" />
              </div>
              <h2 className="text-xl font-semibold text-primary leading-none tracking-tight">
                Nutrition During Pregnancy, Infancy, Childhood and the Elderly
              </h2>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">
                <p className="text-gray-600 leading-relaxed">No matter the stage of the lifecycle you are in, our dietitians can assist you with your nutritional requirements using evidence based approaches.</p>
                
                <h3 className="text-lg font-semibold text-primary mt-8">Life Stage Nutrition</h3>
                <p className="text-gray-600 leading-relaxed">Nutritional needs change throughout life. Our dietitians provide personalised nutrition guidance for each life stage, ensuring optimal health and development.</p>
                
                <h3 className="text-lg font-semibold text-primary">Our Services</h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-primary">Pregnancy & Preconception</h4>
                    <p className="text-gray-600">Nutritional guidance for healthy pregnancy and optimal foetal development</p>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-primary">Infant Nutrition</h4>
                    <p className="text-gray-600">Support for breastfeeding mothers, formula feeding, and introduction to solid foods</p>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-primary">Childhood Nutrition</h4>
                    <p className="text-gray-600">Promoting healthy eating habits and addressing paediatric nutritional concerns</p>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-primary">Elderly Nutrition</h4>
                    <p className="text-gray-600">Addressing the unique nutritional needs of older adults to maintain health and independence</p>
                  </div>
                </div>
                
                <h3 className="text-lg font-semibold text-primary">Our Approach</h3>
                <p className="text-gray-600 leading-relaxed">
                  We provide practical, evidence-based nutrition guidance that considers the unique physiological needs, preferences, and lifestyle factors at each life stage.
                </p>
                
                <div className="mt-8 flex justify-center">
                  <Link to="/booking">
                    <Button size="lg" className="bg-primary hover:bg-primary-light text-white px-8">
                      Book a Consultation
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </>;
};
export default LifecycleNutrition;